import React, { useState, useEffect } from "react";
import DragAndDropImage from "../../../../../../components/ImageUpload/imageUpload";
import { useSelector } from "react-redux";

const PictureComponent = ({
  mediaData,
  handleCreateMedia,
  handleMediaDelete,
  selectedAsset,
}) => {
  const [uploadedImages, setUploadedImages] = useState([]);
  const { userAssetLoading } = useSelector((state) => state.userAssets);

  useEffect(() => {
    const filteredImages =
      mediaData?.filter((image) => {
        const ext = image.name?.split(".").pop().toLowerCase();
        return ["png", "jpg", "jpeg", "webp", "gif"].includes(ext);
      }) || [];

    setUploadedImages(filteredImages);
  }, [mediaData]);

  const handleImagesUpdate = (images) => {
    setUploadedImages(images);
    handleCreateMedia(images);
  };

  return (
    <div className="">
      <h2 className="text-2xl text-lightPrimary dark:text-primary-gradient font-semibold p-4">
        {userAssetLoading ? (
          <span className="animate-pulse inline-block h-6 w-48 bg-gray-200 dark:bg-gray-700 rounded"></span>
        ) : selectedAsset?.name ? (
          `Luxury Asset - ${selectedAsset?.name}`
        ) : (
          "No Asset found"
        )}
      </h2>

      <div className="p-4">
        <h3 className="text-lg font-semibold mt-6 text-lightPrimary dark:text-primary-gradient">
          Uploaded Images:
        </h3>
        <DragAndDropImage
          onImagesUpdate={handleImagesUpdate}
          handleMediaDelete={(mediaId) => handleMediaDelete(mediaId, "Image")}
          uploadedImages={uploadedImages}
          accept=".png,.jpg,.jpeg,.webp,.gif"
          showPic={3}
        />
      </div>
    </div>
  );
};

export default PictureComponent;
